export default __webpack_public_path__ + "static/tonga-84892a3e682a54e552d84d9e36d8c801.jpg";